import React from 'react';
import { type ListItemProps } from './ListItem';
import { DropDown, type DropDownProps, VideoThumbnail } from '@/molecules';
import { SharedAsset, VideoThumbnailPlaceholder, Lock } from '@/svgs';
import { colors, rebrandColors } from '@/styles';

type ListItemDetailsProps = ListItemProps & {
  // eslint-disable-next-line react/require-default-props
  menuItems?: DropDownProps['menuItems'];
};

function properCase(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export default function ListItemDetails({
  video = {} as unknown as ListItemProps['video'],
  team = '',
  title = '',
  subtitle = '',
  isRebrand = false,
  handleDropDown = () => {},
  onMenuOpen = () => {},
  enableUpwardMenus = false,
  menuDirection = 'down',
  disabled = false,
  menuItems = [],
  shouldShowMenu = true,
  showReviewStatus = false,
}: ListItemDetailsProps) {
  if (!video) {
    return null;
  }

  return (
    <>
      <div className="thumbnail">
        {video.status ? (
          <VideoThumbnail
            status={video.status}
            progress={video.progress}
            thumbnail={video.thumbnail}
          />
        ) : (
          <VideoThumbnailPlaceholder size="100%" />
        )}
        {team !== '' && (
          <div className="shared-icon">
            <SharedAsset size="3" title="Shared" />
          </div>
        )}
      </div>
      <div className="info">
        {video.status && (
          <>
            <div className="title" title={title}>
              {showReviewStatus && video.reviewStatus && (
                <div className="review-status">
                  <span>{properCase(video.reviewStatus)}</span>
                </div>
              )}
              {title}
              {video.securityType && video.securityType !== 'link' && (
                <Lock
                  className="lock"
                  title={video.securityType}
                  fill={isRebrand ? rebrandColors.disableGrey : colors.taosSky}
                  size="3.9"
                />
              )}
            </div>
            <div className="subtitle" title={typeof subtitle === 'string' ? subtitle : ''}>
              {subtitle}
            </div>
            {team !== '' && <div className="team">{team}</div>}
            {video.ctaLink && (
              <div className="cta-badge">
                <span>CTA</span>
                <span className="tooltip">
                  Reminder: This Call-to-Action will always be included in this video.
                </span>
              </div>
            )}
          </>
        )}
      </div>
      {shouldShowMenu && (
        <div className="menu" data-testid="menu-dropdown">
          <DropDown
            className="list-item--menu-dropdown"
            onChange={handleDropDown}
            onOpen={(opened) => {
              if (opened) {
                onMenuOpen(video?.id);
              }
            }}
            direction={enableUpwardMenus ? menuDirection : 'down'}
            menuItems={menuItems}
            title="Menu"
            type="dots-horizontal"
            disabled={disabled || !video.status}
            size="small"
            isRebrand={isRebrand}
          />
        </div>
      )}
    </>
  );
}
